import React, {useContext, useEffect, useState} from 'react'
import {CardMedia, IconButton} from '@mui/material'
import {AddRounded as AddIcon, RemoveRounded as RemoveIcon} from '@mui/icons-material'
import {checkUndefined, clearText, isEmpty, isMobile} from 'react-lf-tools'
import {general as textsGeneral, itemBag as textsItemsBag} from '../../../../translate/Translate.jsx'
import {getLocal, setLocal} from '../../../../hooks/useStorage/useStorage.jsx'
import {ItemBagContext} from '../../../../context/ItemBagContext.jsx'

import './stepAdditional.scss'

const StepAdditional = ({
                            title,
                            options,
                            filterFlavor,
                            mandatory,
                            minSelection,
                            maxSelection,
                            step,
                            stepIndex,
                            priceStep,
                            amountType,
                            onNext
                        }) => {
    let {additional, setAdditional, setSnackbar, isEdit, item, itemDelete, setItemDelete, setTour} =
        useContext(ItemBagContext)
    const [amountSelection, setAmountSelection] = useState(0)
    const [viewMandatory, setViewMandatory] = useState(false)
    const [items, setItems] = useState({})
    const [listOptions, setListOptions] = useState([])
    const [filter, setFilter] = useState('')
    const [settings, setSettings] = useState({
        showPhoto: false,
        showDescription: false
    })
    const handleClick = (flavor) => {
        flavor = (flavor === 'Todos') ? '' : flavor
        if (flavor === '') {
            setListOptions(options)
            setFilter(flavor)
            return
        }
        const list = options.filter(item => (item.category === flavor))
        setListOptions(list)
        setFilter(flavor)
    }
    const handleChangeAdd = (option) => {
        if (amountSelection >= maxSelection) return setSnackbar({
            open: true,
            message: textsItemsBag.limitMaximum
        })
        option.valuePercentage = option.price
        option.priceProduct = option.price
        option.priceStep = priceStep
        option.amount = 1
        option.step = step
        option.stepIndex = stepIndex
        const amount = checkUndefined(items[option.sku], 0)
        setItems({...items, [option.sku]: (amount + 1)})
        setAmountSelection((amountSelection + 1))
        if (!isEmpty(additional[stepIndex])) {
            additional[stepIndex].push(option)
        } else {
            additional[stepIndex] = [option]
        }
        checkAdditionalValues()
        setAdditional({...additional})
        checkTourFilter(option.sku)
        setViewMandatory(isMandatory())
        if (isMaximum()) onNext(stepIndex)
    }

    const isMandatory = () => {
        try {
            const selection = additional[stepIndex].reduce((total, item) => total + item.amount, 0)
            return (selection >= minSelection)
        } catch (e) {
            console.error(e.message)
        }
        return false
    }

    const isMaximum = () => {
        try {
            const selection = additional[stepIndex].reduce((total, item) => total + item.amount, 0)
            return (selection === maxSelection)
        } catch (e) {
            console.error(e.message)
        }
        return false
    }

    const checkTourFilter = (sku) => {
        const tour = getLocal('tourFilter', '')
        if (!tour && sku.includes('S')) setTimeout(() => setTour({
            open: true,
            step: 0
        }), 100)
        setLocal('tourFilter', 'ok')
    }
    const handleChangeRemove = (option) => {
        if (amountSelection <= minSelection) setSnackbar({
            open: true,
            message: textsItemsBag.limitMinimum
        })
        const amount = isEmpty(items[option.sku]) ? 0 : items[option.sku]
        if (amount !== 0) {
            setItems({...items, [option.sku]: (amount === 1) ? 0 : (amount - 1)})
            setAmountSelection((amountSelection - 1))
            const index = additional[stepIndex].findIndex((additional) => (additional.sku === option.sku))
            additional[stepIndex].splice(index, 1)
            checkAdditionalValues()
            setAdditional({...additional})
        }
        setViewMandatory(isMandatory())
    }
    const handleDelete = () => {
        try {
            if (!isEmpty(itemDelete)) {
                setItems({...items, [itemDelete.sku]: 0})
                const amount = isEmpty(items[itemDelete.sku]) ? 0 : items[itemDelete.sku]
                setAmountSelection((amountSelection - amount))
                const index = additional[itemDelete.stepIndex].findIndex((additional) => (additional.sku === itemDelete.sku))
                if (index === -1) return
                additional[itemDelete.stepIndex].splice(index, 1)
                checkAdditionalValues()
                setAdditional({...additional})
                setItemDelete({})
            }
        } catch (e) {
            console.error(e.message)
        }
    }
    const checkAdditionalValues = () => {
        if (amountType === 'AVERAGE') {
            const numberOfAdditional = additional[stepIndex].reduce((total, item) => (total + item.amount), 0)
            additional[stepIndex].forEach(a => {
                a.valuePercentage = (a.priceProduct / numberOfAdditional)
            })
        } else if (amountType === 'MAXVALUE') {
            const numberOfAdditional = additional[stepIndex].reduce((total, item) => total + item.amount, 0)
            if (numberOfAdditional === 0) {
                additional[stepIndex] = []
            } else {
                const flavor = additional[stepIndex].reduce((previousItem, currentItem) => (previousItem.price > currentItem.price ? previousItem : currentItem))
                additional[stepIndex].forEach(a => {
                    a.valuePercentage = (flavor.price / numberOfAdditional)
                })
            }
        }
    }
    const checkAdditional = () => {
        if (isEdit) {
            findAdditionalBySku(options, item)
        }
    }
    const findAdditionalBySku = (options, item) => {
        for (const s in item.subitems) {
            for (const o in options) {
                if (item.subitems[s].sku === options[o].sku) {
                    addAdditional(item.subitems[s])
                }
            }
        }
    }
    const addAdditional = (option) => {
        option.step = step
        option.stepIndex = stepIndex
        option.priceStep = priceStep
        items[option.sku] = option.amount
        setAmountSelection((amountSelection + 1))
        if (!isEmpty(additional[stepIndex])) {
            additional[stepIndex].push(option)
        } else {
            additional[stepIndex] = [option]
        }
        checkAdditionalValues()
        setAdditional({...additional})
        setItems({...items})
    }
    useEffect(() => {
        checkAdditional()
    }, [])
    useEffect(() => {
        handleDelete()
    }, [itemDelete])
    useEffect(() => {
        const data = getLocal('data')
        setSettings({
            showPhoto: data.showPhoto,
            showDescription: data.showDescription
        })
        setListOptions(options)
    }, [])
    return <div className={'step-observations'}>
        <div className={'card-step'} id={`step${stepIndex}`}>
            <div className={'div-title-step'}>
                <label className={'label-title-step'}>
                    {title}
                </label>
                <div className={'div-title-mandatory'}>
                    {(mandatory && !viewMandatory) && <div className={'div-mandatory-step'}>
                        <label className={'label-mandatory-step'}>
                            {textsGeneral.mandatory}
                        </label>
                    </div>}
                    {!!priceStep && <div className={'div-mandatory-step'}>
                        <label className={'label-mandatory-step'}>
                            {priceStep.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })}
                        </label>
                    </div>}
                </div>
            </div>
            {(!!filterFlavor.length) && <div className={'div-filters-flavor'}>
                {filterFlavor.map((flavor, i) => <div
                    className={'flavor'}
                    id={((filter === flavor) || (filter === '' && flavor === 'Todos')) ? 'selected' : ''}
                    key={i}
                    onClick={() => handleClick(flavor)}>
                    <label>
                        {flavor}
                    </label>
                </div>)}
            </div>}
            <div className={'div-items-step'}>
                {listOptions.map((option, i) => <div className={'div-description-step'} key={i}
                                                     id={clearText(option.option)}>
                    {(settings.showPhoto) && <div className={'div-image-option'}>
                        {(!!option.image) && <CardMedia
                            image={option.image}
                            className={'card-media-step'}/>}
                    </div>}
                    <div className={'div-description-price-step'}>
                        <div className={'div-description-price-step-row'}>
                            <div
                                className={'div-additional-step'}
                                style={((isMobile()) && ((!!option.image) && (settings.showPhoto))) ? {} : {}/*era maxWidth: 200*/}>
                                <label>
                                    {option.option}
                                </label>
                                {(settings.showDescription || option.sku.includes('S')) &&
                                    <label
                                        className={'description'}>
                                        {option.description}
                                    </label>}
                                {(option.price !== 0) && <label className={'label-price-step'}>
                                    {(amountType !== 'AVERAGE')
                                        ? `${option.price.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}`
                                        : `${(option.price / maxSelection).toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })} ${textsItemsBag.byFlavor}`
                                    }
                                </label>}
                                {(!isEmpty(option.oldPrice) && option.oldPrice !== 0) &&
                                    <label className={'label-old-price-step'}>
                                        {option.oldPrice.toLocaleString('pt-BR', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                    </label>}
                            </div>
                            <div className={'div-buttons-additional'}>
                                {((!isEmpty(items[option.sku])) && (items[option.sku] !== 0)) && <>
                                    <IconButton
                                        className={'icon-button-addicional'}
                                        onClick={() => handleChangeRemove(option)}>
                                        <RemoveIcon className={'icon'}/>
                                    </IconButton>
                                    <label className={'label-amount'}>
                                        {items[option.sku]}
                                    </label>
                                </>}
                                <IconButton
                                    className={'icon-button-addicional'}
                                    onClick={() => handleChangeAdd(option)}>
                                    <AddIcon className={'icon'}/>
                                </IconButton>
                            </div>
                        </div>
                    </div>
                </div>)}
            </div>
        </div>
    </div>
}

export default StepAdditional
